<template>
    <!-- 闹钟设置 -->
    <div class="alarm-clock">
        <div class="top-box">
            <el-button type="primary" @click='dialogClick'>新增</el-button>
        </div>
        <div class="Table-Bottom">
            <el-table :header-cell-style="{ background: '#fff', color: '#000', height: '40px', }" ref="multipleTable"
                :data="tableData" :cell-style="{ 'text-align': 'center' }" tooltip-effect="dark"
                @selection-change="handleSelectionChange">
                <el-table-column prop="address" label="闹钟名称" width="85" show-overflow-tooltip>
                    <template #default="scope">
                        <!-- <span>{{ scope.row.name }}</span> -->
                        <span v-for=" item in JSON.parse(scope.row.day)" :key="item" v-if="scope.row.day" >
                            <span v-if="item == 1"> {{'周一'}}, </span>
                            <span v-if="item == 2"> {{'周二'}}, </span>
                            <span v-if="item == 3"> {{'周三'}}, </span>
                            <span v-if="item == 4"> {{'周四'}}, </span>
                            <span v-if="item == 5"> {{'周五'}}, </span>
                            <span v-if="item == 6"> {{'周六'}}, </span>
                            <span v-if="item == 7"> {{'周日'}}, </span>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="informTime" label="闹钟时间" show-overflow-tooltip>
                    <template #default="scope">
                        {{ scope.row.informTime }}
                    </template>
                </el-table-column>
                <el-table-column prop="" label="" show-overflow-tooltip>
                    <template #default="scope">
                        <el-switch v-model="scope.row.delivery" @change="switchClick(scope.row)"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column
                prop="address"
                label="操作"
                show-overflow-tooltip>
                <template #default="scope">
                    <span @click="deleteClick(scope.row)" class="delete-title">删除</span>
                    <!-- <span @click="xiugaiClick(scope.row)" class="delete-xiugai">修改</span> -->

                </template>
                </el-table-column>

                </el-table>
            </div>
            <el-dialog
                v-model="dialogVisible"
                title="闹钟设置"
                width="30%"
                :before-close="handleClose"
            >
            <div class="time-box">
                <el-form-item label="时段" label-width="60px">
                    <el-time-picker
                    v-model="value1"
                    :format="'HH:mm'"
                    value-format="HH:mm"
                    placeholder="">
                </el-time-picker>
                </el-form-item>
            </div>
            <el-form-item label="" label-width="60px">
                <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                    <el-checkbox v-for="city in cities" :label="city.value" :key="city.value">{{city.name}}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
                
            <template #footer>
            <span class="dialog-footer">
                <el-button @click="handleClose">取消</el-button>
                <el-button type="primary" @click="addClose">
                确定
                </el-button>
            </span>
            </template>
        </el-dialog>
    </div>
</template>
<!-- buzhi = {
} -->
<script>
import { alarmClock,addAlarmClock,deleteAlarmClock,updateAlarmClock } from '@/assets/api/zhongduan.js'

export default {
    components: {

    },
    data() {
        return {
            tableData: [

            ],
            dialogVisible: false,
            value1: [],
            cities: [ 
                {
                    name: '周一',
                    value:1
                },
                {
                    name: '周二',
                    value:2
                },
                {
                    name: '周三',
                    value:3
                },
                {
                    name: '周四',
                    value:4
                },
                {
                    name: '周五',
                    value:5
                },
                {
                    name: '周六',
                    value:6
                },
                {
                    name: '周日',
                    value:7
                },
            ],
            checkedCities: []
        };
    },
    created() {
        this.alarmClockList()
    },
    mounted() {

    },
    methods: {
        dialogClick () {
            this.dialogVisible = true
            this.value1 = []
            this.checkedCities = []
        },
        alarmClockList () {
            let params = {
                imei: this.$route.query.iemi,
            } 
            alarmClock(params).then((res)=> {
                console.log(res,'亲情号码列表');
                    for ( let item of res.data.data ) {
                        if ( item.onOff == 1 ) {
                            item.delivery = true    
                        } else {
                            item.delivery = false    
                        }
                    }
                    this.tableData = res.data.data
            }).catch((err) => {
                console.log(err);
            })
        },
        handleCheckedCitiesChange (value) {
            console.log(value,77899);
        },
        handleClose () {
            this.dialogVisible = false
        },
        addClose () {
            let params = {
                imei:this.$route.query.iemi,
                informTime:this.value1,
                onOff: 1, // 开关
                repetition: 3, // 是否重复(1:不重复；3重复)
                remark: '',
                day: this.checkedCities,
            } 
            addAlarmClock(params).then((res)=> {
                console.log(res,'123456');
                this.alarmClockList()
                this.dialogVisible = false
            }).catch((err) => {
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
            })
            console.log('新增',this.value1);
        },
        deleteClick (item) {
            let params = {
                id: item.id,
            } 
            deleteAlarmClock(params).then((res)=> {
                console.log(res,'删除');
                this.$message({
                    message: '删除成功！',
                    type: 'success'
                });
                this.alarmClockList()
            }).catch((err) => {
                // console.log(err);
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
            })
        },
        switchClick (item) {
            let params = {
                id: item.id,
                onOff: item.delivery? '1':'0'
            } 
            updateAlarmClock(params).then((res)=> {
                console.log(res,'删除');
                this.$message({
                    message: '修改成功！',
                    type: 'success'
                });
                this.alarmClockList()
            }).catch((err) => {
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
            })
            console.log('开关',item);
        },  
    },
};
</script>

<style scoped lang="scss">
.alarm-clock {
    .top-box {
        margin-top: 15px;
    }
    .Table-Bottom {
        width: 720px; /*no*/
        border: 1px solid #eee;
        margin-top: 20px;

        :deep() {
            .el-input {
                width: 160px;
            }

            .el-table th.el-table__cell>.cell {
                text-align: center;
                font-size: 15px;
            }
        }
    }

    .bottom-but {
        margin: 20px 0px;
        margin-left: 130px;
    }
    .time-box {
        width: 80%;
    }
    .delete-title {
        color: red;
        cursor: pointer;
        margin-right: 5px;

    }
    .delete-xiugai{
        color: #459FFC;
    }
}
</style>
